import axios from 'axios';
import { translate } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

export const ACTION_TYPES = {
  SEND_OTP: 'register/SEND_OTP',
  RESET: 'register/RESET',
  RE_SEND_OTP: 'register/RE_SEND_OTP',
  OTP_UPDATE_PHONE: 'register/OTP_UPDATE_PHONE',
  STORE_INFO_NEW_PHONE: 'register/STORE_INFO_NEW_PHONE',
  UPDATE_NEW_PHONE_NUMBER: 'UPDATE_NEW_PHONE_NUMBER',
  RESEND_OTP_UPDATE_NEW_PHONE_NUMBER: 'RESEND_OTP_UPDATE_NEW_PHONE_NUMBER'
};

const initialState = {
  loading: false,
  response: {} as any,
  responseReSend: {} as any,
  registrationFailure: false,
  responseSendOtpUpdatePhone: {} as any,
  infoNewPhone: {} as any,
  updatePhone: {} as any,
  resendOtpUpdatePhone: {} as any
};

export type SendOtpState = Readonly<typeof initialState>;

// Reducer
export default (state: SendOtpState = initialState, action): SendOtpState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEND_OTP):
      return {
        ...state,
        loading: true
      };
    case REQUEST(ACTION_TYPES.RE_SEND_OTP):
    case REQUEST(ACTION_TYPES.OTP_UPDATE_PHONE):
    case REQUEST(ACTION_TYPES.UPDATE_NEW_PHONE_NUMBER):
    case REQUEST(ACTION_TYPES.RESEND_OTP_UPDATE_NEW_PHONE_NUMBER):
      return {
        ...state
      };
    case FAILURE(ACTION_TYPES.SEND_OTP):
      return {
        ...state,
        registrationFailure: true,
        loading: false
      };
    case SUCCESS(ACTION_TYPES.SEND_OTP):
      return {
        ...state,
        registrationFailure: false,
        loading: false,
        response: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.OTP_UPDATE_PHONE):
      return {
        ...state,
        loading: false,
        responseSendOtpUpdatePhone: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPDATE_NEW_PHONE_NUMBER):
      return {
        ...state,
        loading: false,
        updatePhone: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RESEND_OTP_UPDATE_NEW_PHONE_NUMBER):
      return {
        ...state,
        loading: false,
        resendOtpUpdatePhone: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RE_SEND_OTP):
      return {
        ...state,
        loading: false,
        responseReSend: action.payload.data
      };
    case FAILURE(ACTION_TYPES.UPDATE_NEW_PHONE_NUMBER):
      return {
        ...state,
        loading: false,
        updatePhone: action.payload.data
      };
    case ACTION_TYPES.STORE_INFO_NEW_PHONE:
      return {
        ...state,
        loading: false,
        infoNewPhone: action.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

// Actions
const apiUrl = 'api/register';
export const otpUpdatePhone = (phone, keyLogin, captcha) => ({
  type: ACTION_TYPES.OTP_UPDATE_PHONE,
  payload: axios.get(`${apiUrl}/otp/update/phone`, {
    params: {
      phone: phone,
      keyLogin: keyLogin,
      captcha: captcha
    }
  })
});

export const updatePhoneNumber = (phone, keyLogin, otp, id) => ({
  type: ACTION_TYPES.UPDATE_NEW_PHONE_NUMBER,
  payload: axios.post(`${apiUrl}/update/phone`, null, {
    params: {
      phone: phone,
      keyLogin: keyLogin,
      otp: otp,
      id: id
    }
  })
});

export const resendOtpUpdatePhoneNumber = (phone, captcha) => ({
  type: ACTION_TYPES.RESEND_OTP_UPDATE_NEW_PHONE_NUMBER,
  payload: axios.get(`${apiUrl}/resend/otp/update/phone`, {
    params: {
      phone: phone,
      captcha: captcha
    }
  })
});

export const storeInfoNewPhone = data => ({
  type: ACTION_TYPES.STORE_INFO_NEW_PHONE,
  data
});

export const sendOtp = (id, key) => ({
  type: ACTION_TYPES.SEND_OTP,
  payload: axios.get(`${apiUrl}/activate/${id}`, {
    params: {
      key: key
    }
  })
});

export const reSendOtp = (id, type, content) => ({
  type: ACTION_TYPES.RE_SEND_OTP,
  payload: axios.get(`${apiUrl}/otp/${id}`, {
    params: {
      type: type,
      content: content
    }
  })
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
